<template>
  <v-dialog v-model="exibir" scrollable width="1200px">

    <v-card color="#fafafa">
      <v-toolbar dark color="primary" dense flat>
        <v-toolbar-title>
          <span>Faturamento de Pedido</span>
          <span> - Nº {{ pedido.id }}</span>
          <span v-if="pedido.cliente"> - {{ pedido.cliente.razao }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click.native="exibir = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-2">
        <v-row dense>
          <v-col cols="12" sm="12">

            <v-card rounded="lg">
              <!-- <v-card-title class="text-subtitle-2">Dados do Pedido</v-card-title>
              <v-divider></v-divider> -->

              <v-card-text>
                <v-row dense>
                  <v-col cols="12" sm="2">
                    <v-text-field
                      filled
                      dense
                      label="Número"
                      v-model="pedido.id"
                      hide-details
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <!-- <v-text-field label="Data" v-model="pedido.data" append-icon="event"></v-text-field> -->
                    <z-date-picker-menu
                      filled
                      dense
                      label="Data"
                      v-model="pedido.data"
                      hide-details
                      readonly
                    ></z-date-picker-menu>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <v-text-field
                      filled
                      dense
                      label="Cliente"
                      v-model="pedido.cliente.razao"
                      hide-details
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      filled
                      dense
                      label="Vendedor"
                      v-model="pedido.vendedor.nome"
                      hide-details
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <z-campo-valor
                      filled
                      dense
                      v-model="pedido.valor_bruto"
                      label="Total Bruto"
                      hide-details
                      readonly
                    ></z-campo-valor>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <v-select
                      filled
                      dense
                      :items="['R$', '%']"
                      v-model="pedido.tipo_desconto"
                      label="Tipo Desconto"
                      @change="calcularTotais"
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <z-campo-valor
                      filled
                      dense
                      v-model="pedido.desconto_valor"
                      label="Valor Desconto"
                      @input="calcularTotais"
                      hide-details
                    ></z-campo-valor>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <z-campo-valor
                      filled
                      dense
                      v-model="pedido.valor_liquido"
                      label="Total Líquido"
                      hide-details
                      readonly
                    ></z-campo-valor>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="3">
          
            <v-card rounded="lg">
              <v-card-title class="text-subtitle-2">Formas de Pagamento</v-card-title>
              <v-divider></v-divider>
              <v-card-text class="py-2">
                <v-row dense>
                  <v-col cols="12" sm="12">
                    <v-select
                      ref="forma_pagamento"
                      filled
                      dense
                      v-model="forma_pagamento"
                      label="Forma de Pagamento"
                      hide-details
                      :readonly="visualizando"
                      :items="$globals.FORMAS_DE_PAGAMENTO"
                      @change="onChangeFormaPagamento"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      filled
                      dense
                      flat
                      v-model="numero_parcelas"
                      ref="parcelas"
                      label="Parcelas"
                      type="tel"
                      hide-details
                      maxlength="2"
                      :readonly="visualizando"
                      :disabled="isAVista || isSaldoZerado"
                      @focus="$event.target.select()"
                      @click:prepend="decrementParcelas"
                      @click:append-outer="incrementParcelas"
                    >
                      <template #append>
                        <v-btn icon color="primary" @click="incrementParcelas" :disabled="isAVista || isSaldoZerado">
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-btn icon color="primary" @click="decrementParcelas" :disabled="isAVista || isSaldoZerado">
                          <v-icon>mdi-minus</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      filled
                      dense
                      flat
                      v-model="prazo"
                      label="Prazo"
                      suffix="dias"
                      type="tel"
                      maxlength="3"
                      hide-details
                      :disabled="isAVista || isSaldoZerado"
                      :readonly="visualizando"
                      @focus="$event.target.select()"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" sm="12">
                    <z-campo-valor
                      filled
                      dense
                      flat
                      :value="saldo"
                      label="Saldo a Pagar"
                      hide-details
                      readonly
                    ></z-campo-valor>
                  </v-col> -->
                  <v-col cols="12" sm="12">
                    <z-campo-valor
                      v-model="valor_parcela"
                      ref="valor_parcela"
                      filled
                      dense
                      flat
                      label="Valor Recebimento"
                      hide-details
                      @keyup.enter="receberValor"
                    ></z-campo-valor>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <!-- <v-row dense>
                      <v-col cols="6">
                        <v-btn
                          block
                          depressed
                          color="primary"
                          class="mr-1"
                          :disabled="saldo == 0"
                          @click="gerarParcelas"
                        >Gerar</v-btn>
                      </v-col>
                      <v-col cols="6">
                        <v-btn block text @click="parcelas = []">Limpar</v-btn>
                      </v-col>
                    </v-row> -->
                    <!-- <v-row dense>
                      <v-col cols="12">
                        <v-btn color="primary" block depressed @click="receberValor">Receber</v-btn>
                      </v-col>
                    </v-row> -->
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn color="primary" block depressed @click="receberValor">Receber</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

          <v-col cols="12" sm="9">
            <v-card rounded="lg" style="height: 100%" ref="card_parcelas">
              <v-toolbar dense color="white" flat ref="toolbar_parcelas">
                <v-toolbar-title class="text-subtitle-2">Pagamentos <span v-if="parcelas.length > 0">({{ parcelas.length  }})</span></v-toolbar-title>
                <v-spacer></v-spacer>
                <span class="text-subtitle-1">SALDO A PAGAR: <b>R$ {{ saldo | valorBR }}</b></span>
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text class="pa-2 pb-3" style="position: absolute; max-height: calc(100% - 48px); overflow-y: auto;">
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="column text-center" style="width: 0;">#</th>
                      <th class="column text-left" style="width: 260px">Tipo Pagamento</th>
                      <th class="column text-left" style="width: 200px">Vencimento</th>
                      <th class="column text-right" style="width: 200px">Valor</th>
                      <th class="column text-right" style="width: 0" v-if="!visualizando">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(parcela, index) in parcelas" :key="index">
                      <td>{{ index + 1 }}/{{ parcelas.length }}</td>
                      <td>
                        {{ parcela.forma_pagamento }}
                        <!-- <v-select
                          class="transparente_"
                          v-model="parcela.forma_pagamento"
                          single-line
                          hide-details
                          solo
                          dense
                          flat
                          :items="$globals.FORMAS_DE_PAGAMENTO"
                          @change="onChangeFormaPagamentoParcela(parcela)"
                        ></v-select> -->
                      </td>
                      <td>
                        <z-date-picker-menu
                          transparente
                          v-model="parcela.vencimento"
                          :value="parcela.vencimento"
                          single-line
                          hide-details
                          solo
                          dense
                          flat
                          raise-on-focus
                          :disabled="isPagamentoAVista(parcela.forma_pagamento)"
                        ></z-date-picker-menu>
                      </td>
                      <td>
                        <z-campo-valor
                          transparente
                          v-model="parcela.valor"
                          single-line
                          hide-details
                          solo
                          dense
                          flat
                          raise-on-focus
                          decimais="2"
                        ></z-campo-valor>
                      </td>
                      <td class="text-right" v-if="!visualizando">
                        <v-btn icon @click="excluirParcela(parcela)">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="fechar" :disabled="salvando">Cancelar</v-btn>
        <v-btn
          v-if="!visualizando"
          depressed
          color="primary"
          :disabled="this.saldo > 0"
          :loading="salvando"
          @click="salvar"
        >Faturar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
export default {
  name: "faturamento",

  data: () => ({
    pedido: {
      cliente: {
        razao: "",
      },
      vendedor: {
        nome: "",
      },
    },
    exibir: false,
    forma_pagamento: "Duplicata",
    numero_parcelas: 1,
    prazo: 30,
    tipo_desconto: "R$",
    parcelas: [],
    valor_parcela: 0,
    salvando: false,
    visualizando: false,
    PAGAMENTOS_A_VISTA: ["À Vista", "Dinheiro", "PIX", "Haver", 'Cartão de Crédito', 'Cartão de Débito'],
    maxHeightParcelas: "300px",
  }),

  computed: {
    totalBruto() {
      return this.pedido.produtos.reduce(
        (soma, produto) => soma + produto.valor,
        0
      );
    },

    totalLiquido() {
      return this.totalBruto - Number(this.pedido.taxa_valor);
    },

    totalParcelas() {
      return this.parcelas.reduce((soma, parcela) => soma + Number(parcela.valor), 0);
    },

    saldo() {
      let saldo = this.trunc(this.pedido.valor_liquido - this.totalParcelas);
      return saldo > 0 ? saldo : 0;
    },

    config() {
      return this.$store.state.configuracoes;
    },

    isAVista() {
      return this.isPagamentoAVista(this.forma_pagamento);
    },

    isDinheiro() {
      return this.forma_pagamento == "Dinheiro";
    },

    isSaldoZerado() {
      return this.saldo == 0;
    }
  },

  methods: {
    ...mapActions("pedidos", ["abrir", "faturar", "faturas"]),

    async abrirFaturamento(pedido) {
      await this.abrir(pedido.id);
      this.pedido = this.clone(this.$store.state.pedidos.pedido);
      this.forma_pagamento = this.pedido.forma_pagamento;
      this.exibir = true;
      this.valor_parcela = this.saldo;


      // if (this.parcelas.length == 0 && this.pedido.situacao == "Orçamento") {
      //   this.gerarParcelas();
      // }

      
      setTimeout(() => {
        this.maxHeightParcelas = (Number(this.$refs.card_parcelas.$el.clientHeight) - Number(this.$refs.toolbar_parcelas.$el.clientHeight)) + "px";
      }, 10);
    },

    async visualizarFaturamento(pedido) {
      this.pedido = await this.faturas(pedido.id);
      this.parcelas = this.pedido.contasreceber;
      this.forma_pagamento = this.pedido.forma_pagamento;
      this.exibir = true;
      this.visualizando = true;
      // this.abrirFaturamento(pedido);
    },

    fechar() {
      this.forma_pagamento = "Duplicata";
      this.numero_parcelas = 1;
      this.prazo = 30;
      this.tipo_desconto = "R$";
      this.parcelas = [];
      this.visualizando = false;
      this.exibir = false;
    },

    receberValor() {
      let valor_parcela = parseInt(this.valor_parcela / Number(this.numero_parcelas));
      let total_parcelas = valor_parcela * this.numero_parcelas;
      let resto = this.trunc(this.valor_parcela - total_parcelas);
      let ultima_parcela = valor_parcela + resto;

      if (this.valor_parcela > this.saldo) {
        return;
      }

      // this.parcelas = [];
      if (this.valor_parcela > 0) {
        for (let parcela = 1; parcela <= this.numero_parcelas; parcela++) {
          let dias = parcela * this.prazo;
          let vencimento;

          if (this.numero_parcelas == 1 && (this.isPagamentoAVista(this.forma_pagamento))) {
            vencimento = this.$moment(new Date()).format("YYYY-MM-DD");
          } else {
            vencimento = this.$moment(this.pedido.data).add(dias, "days").format("YYYY-MM-DD");
          }

          this.parcelas.push({
            forma_pagamento: this.forma_pagamento,
            vencimento: vencimento,
            valor: parcela == 1 ? ultima_parcela : valor_parcela,
          });
        }

        this.valor_parcela = 0;
        this.numero_parcelas = 1;
        this.prazo = 30;
        this.$refs.forma_pagamento.focus();
        setTimeout(() => {
          this.$refs.valor_parcela.focus();
        }, 0);
      }
    },

    gerarParcelas() {
      let valor_parcela = parseInt(this.saldo / Number(this.numero_parcelas));
      let total_parcelas = valor_parcela * this.numero_parcelas;
      let resto = this.trunc(this.saldo - total_parcelas);
      let ultima_parcela = valor_parcela + resto;

      // this.parcelas = [];
      if (this.saldo > 0) {
        for (let parcela = 1; parcela <= this.numero_parcelas; parcela++) {
          let dias = parcela * this.prazo;
          let vencimento;

          if (this.numero_parcelas == 1 && (this.isPagamentoAVista(this.forma_pagamento))) {
            vencimento = this.$moment(new Date()).format("YYYY-MM-DD");
          } else {
            vencimento = this.$moment(this.pedido.data).add(dias, "days").format("YYYY-MM-DD");
          }

          this.parcelas.push({
            forma_pagamento: this.forma_pagamento,
            vencimento: vencimento,
            valor: parcela == 1 ? ultima_parcela : valor_parcela,
          });
        }
      }
    },

    calcularTotais() {
      let desconto;

      this.pedido.itens = this.pedido.produtos.length;
      this.pedido.quantidade_total = this.pedido.produtos.reduce(
        (soma, produto) => soma + Number(produto.quantidade),
        0
      );
      this.pedido.valor_bruto = this.trunc(
        this.pedido.produtos.reduce(
          (soma, produto) => soma + produto.subtotal,
          0
        )
      );

      if (this.pedido.tipo_desconto == "R$") {
        desconto = Number(this.pedido.desconto_valor);
      } else {
        desconto =
          this.pedido.valor_bruto * (Number(this.pedido.desconto_valor) / 100);
      }

      this.pedido.valor_liquido = this.trunc(
        this.pedido.valor_bruto +
          Number(this.pedido.taxa_valor) -
          Number(desconto) +
          Number(this.pedido.frete)
      );

      this.parcelas = [];
    },

    excluirParcela(parcela) {
      let indice = this.parcelas.findIndex((parcela_) => parcela_ == parcela);
      this.parcelas.splice(indice, 1);
    },

    async salvar() {
      if (this.totalParcelas != this.pedido.valor_liquido) {
        this.$eventbus.notificar("O total das parcelas não pode ser diferente do valor líquido.");
        return;
      }

      try {
        this.salvando = true;
        let post = {
          pedido_id: this.pedido.id,
          tipo_desconto: this.pedido.tipo_desconto,
          desconto_valor: this.pedido.desconto_valor,
          valor_liquido: this.pedido.valor_liquido,
          parcelas: this.parcelas,
        };
        await this.faturar(post);
        this.$emit("faturado", this.pedido);
        this.fechar();
      } catch (error) {
        this.$eventbus.erro("Houve um problema ao tentar faturar o pedido.", error);
      } finally {
        this.salvando = false;
      }
    },

    onChangeFormaPagamento() {
      if (this.isAVista) {
        this.numero_parcelas = 1;
        this.prazo = 0;
      } else {
        if (this.prazo == 0) this.prazo = 30;
      }

      this.valor_parcela = this.trunc(this.saldo / Number(this.numero_parcelas));


      setTimeout(() => {
        this.$refs.valor_parcela.focus();
      }, 0);
    },

    onChangeFormaPagamentoParcela(parcela) {
      if (this.isPagamentoAVista(parcela.forma_pagamento)) {
        parcela.vencimento = this.$moment(this.pedido.data).format("YYYY-MM-DD")
      } else {
        parcela.vencimento = this.$moment(this.pedido.data).add(this.prazo, "days").format("YYYY-MM-DD");
      }
    },


    isPagamentoAVista(forma_pagamento) {
      return this.PAGAMENTOS_A_VISTA.indexOf(forma_pagamento) > -1;
    },

    incrementParcelas() {
      if (this.numero_parcelas <= 11) {
        this.numero_parcelas++;
      }
    },

    decrementParcelas() {
      if (this.numero_parcelas > 1) {
        this.numero_parcelas--;
      }
    },
  },


};
</script>

<style scoped>
.transparente >>> .v-input__control > .v-input__slot {
  background: none !important;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: none;
}
</style>
